import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';
import rootReducer from '../_reducers';
import {composeWithDevTools} from "redux-devtools-extension";
import {gtmMiddleware} from "./analytics/analytics.helper";

const loggerMiddleware = createLogger();

/**
 * This is the redux store
 * @type {any}
 */
export const store = createStore(
    rootReducer, composeWithDevTools(
        applyMiddleware(
            thunkMiddleware,
            loggerMiddleware,
            gtmMiddleware,
        )
    )
);